import { Badge } from "@/components/Badge.tsx";

interface AutomatedTopUpBadgeProps {
    value: boolean;
}

export function AutomatedTopUpBadge({ value }: AutomatedTopUpBadgeProps) {
    return <Badge color={value ? "success" : "text"}>{value ? "ENABLED" : "DISABLED"}</Badge>;
}
